import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';

/**
 * Custom hook for querying data from the store.
 * @param {UseQueryOptions} options - The options for the query.
 * @returns {UseQueryResult} - The result of the query.
 */
export function useStoreQuery<TData = unknown, TError = unknown>(
  options: UseQueryOptions<TData, TError>,
): UseQueryResult<NoInfer<TData>, TError> {
  return useQuery<TData, TError>(options);
}
